import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { CloseIcon } from "../../icons";
import "../../pages/signup/signup.css";
import Radio from "@mui/material/Radio";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import RadioGroup, { useRadioGroup } from "@mui/material/RadioGroup";
import EmailVerification from "./EmailVerification/EmailVerification";
import SignupFormRecruiter from "./SignupFormRecruiter";
import SignUpFormTalent from "./SignUpFormTalent";
import { FormControlLabel } from "@mui/material";
import { Link, useParams } from "react-router-dom";

export default function Signup({ open, onClose }) {
  const { pathname, state, hash } = useLocation();
  const { signInTabs, setSignInTabs, user } = useContext(AuthContext);
  const [openMenu, setOpenMenu] = useState(open);
  const [OpenemailVerify, setOpenemailVerify] = useState(false);

  const [role, setRole] = useState(
    pathname == "/recruiters" ? 1 : pathname == "/talents" ? 0 : -1
  );

  const handleClose = () => {
    setOpenMenu(false);
    onClose(false);
    setSignInTabs(null);
    pathname == "/" && setRole(-1);
  };
  const openVerification = () => {
    setOpenemailVerify(true);
    handleClose();
  };
  useEffect(() => {
    setOpenMenu(open);
    pathname === "/" && setRole(-1);
    pathname === "/recruiters" && setRole(1);
    pathname === "/talents" && setRole(0);
    pathname === "/talents/" && setRole(0);
    pathname.includes("/talent/") && setRole(1);
    pathname.includes("/recruiter/") && setRole(-1);
    pathname.includes("/talent/") && setRole(1);
    pathname.includes("/jobs/") && setRole(0);
    pathname === "/find-talents" && setRole(1);
    pathname === "/find-jobs" && setRole(0);
  }, [open]);

  useEffect(() => {
    if (signInTabs === "recruiter") {
      setRole(1);
    }
  }, [signInTabs]);

  return (
    <>
      <EmailVerification
        open={OpenemailVerify}
        onClose={() => {
          setOpenMenu(false);
          setOpenemailVerify(false);
        }}
        back={() => {
          setOpenMenu(true);
          setOpenemailVerify(false);
        }}
      />
      <div
        className={openMenu ? "overlay block" : "hidden"}
        onClick={handleClose}
      ></div>
      <div
        className={openMenu ? "singup__screen signup_open" : "singup__screen"}
      >
        <div className="signup__header flex justify-between items-center">
          <h4 className="font-semibold text-gray-700 signup__title">
            {role >= 0
              ? `Sign Up as a ${role == 1 ? "Recruiter" : "Talent"}`
              : "Select your role below"}
          </h4>
          <CloseIcon className="close_icon" onClick={handleClose} />
        </div>
        <div className="role_selecter1" style={{ marginBottom: 25 }}>
          {pathname === "/" ||
          pathname.includes("/recruiter/") ||
          pathname.includes("/talent/") ? (
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="use-radio-group"
              value={role}
              onChange={(e) => {
                setRole(e.target.value);
              }}
            >
              <FormControlLabel
                value={0}
                control={<Radio />}
                label="I’m a Talent"
                size="small"
                className={role == 0 ? "active_customradio" : "talent"}
              />
              <FormControlLabel
                value={1}
                className={role == 1 ? "active_customradio" : "recruiter"}
                control={<Radio />}
                label="I’m a Recruiter"
                size="small"
              />
            </RadioGroup>
          ) : null}
        </div>
        {/* <div className='role_selecter flex' style={{marginBottom:25}}>
                    <span
                        className={role === 0 ? 'text-center role_btn role_active' : 'text-center role_btn'}
                        onClick={() => { setRole(0) }}>Talent
                    </span>
                    <span className={role === 1 ? 'text-center role_btn role_active' : 'text-center role_btn'}
                        onClick={() => { setRole(1) }}
                    >Recruiter</span>
                    <span className={'text-center role_btn role_active'}
                    >{pathname === '/recruiters' ?"Recruiter" :"Talent"}</span>
                </div> */}
        <div
          className={`form__container ${
            role == 0 || role == 1 ? "" : "disabledform__container"
          }`}
        >
          {/* <div className='form__container'> */}
          {role == 1 ? (
            <SignupFormRecruiter
              open={OpenemailVerify}
              onClose={() => {
                setOpenMenu(false);
                setOpenemailVerify(false);
              }}
            />
          ) : (
            <SignUpFormTalent
              openVerify={() => {
                openVerification();
              }}
            />
          )}
          {/* {role === 0 ? <SignUpFormTalent openVerify={() => { openVerification() }} /> : <SignupFormRecruiter open={OpenemailVerify} onClose={() => { setOpenMenu(false); setOpenemailVerify(false); }} />} */}
        </div>
      </div>
    </>
  );
}
